import {ICheatPluginController} from '../../CheatModuleInterfaces';
import {ISoundTool, SoundProperties, SoundsProperties} from '@gongxigames/framework/slot/types';
import {CoreDI, DataStorage, IEventManagerWithAsync, lazyInject} from '@gongxigames/framework/core';
import {DI} from '@gongxigames/framework/slot/configs/DI';
import {GlobalEventsMap} from '@gongxigames/framework/slot/events';
import {SoundTool} from '@gongxigames/framework/slot/utils';
import {Sound} from '@pixi/sound';
import {SoundManager} from '@gongxigames/framework/slot/services/SoundManager';
import {ResourceManager} from '@gongxigames/framework/slot/services/ResourcesManager';

type CheatSoundToolStorage = {
    loaded: boolean;
};

export class CheatSoundTool implements ICheatPluginController {
    protected _soundTool!: ISoundTool;
    protected _soundsFiles!: string[];

    @lazyInject(DI.SoundManager)
    protected readonly soundManager!: SoundManager;

    @lazyInject(DI.ResourceManager)
    protected readonly resourceManager!: ResourceManager;

    @lazyInject(CoreDI.GameConfig)
    protected readonly game!: ResourceManager;

    @lazyInject(CoreDI.IEventManagerWithAsync)
    protected eventManager!: IEventManagerWithAsync<GlobalEventsMap>;

    public store: DataStorage<CheatSoundToolStorage> = new DataStorage({loaded: false});

    public init(): void {
        this._soundsFiles = [];

        this.eventManager.on('General.ResourcesLoading.LOADED_ALL_RESOURCES', this.onLoadedSounds.bind(this), this);
    }

    protected onLoadedSounds(): void {
        this._soundTool = new SoundTool(this.soundManager);

        for (const sourceName in this.soundManager.audioNamesBySource) {
            if (this.soundManager.audioNamesBySource.hasOwnProperty(sourceName)) {
                this._soundsFiles.push(sourceName);
            }
        }

        this.store.set('loaded', true);
    }

    public stopAllSounds(): void {
        this._soundTool.stopAllSounds();
    }

    public get soundsFiles(): string[] {
        return this._soundsFiles;
    }

    public editSoundConfig(sourceName: string, prop: any, value: any): void {
        this._soundTool.editSound(sourceName, prop, value);
    }

    public playSound(sourceName: string): void {
        this._soundTool.playSound(sourceName);
    }

    public replaceSound(sourceName: string, source: ArrayBuffer): void {
        const sound = Sound.from({source});
        const soundsMap = new Map<string, Sound>([[sourceName, sound]]);

        this._soundTool.replaceSounds(soundsMap);
    }

    public replaceSounds(files: Map<string, ArrayBuffer>): void {
        const soundsMap = new Map<string, Sound>();

        for (const [sourceName, source] of files) {
            soundsMap.set(sourceName, Sound.from(source));
        }

        this._soundTool.replaceSounds(soundsMap);
    }

    public stopSound(sourceName: string): void {
        this._soundTool.stopSound(sourceName);
    }

    public getSoundConfig(sourceName: string): SoundProperties {
        return this._soundTool.getSoundConfig(sourceName);
    }

    public getSoundsConfig(): SoundsProperties {
        return this._soundTool.soundsProperties;
    }

    public isLoaded(): boolean {
        return this.store.data.loaded;
    }
}
